import React, { useState, useRef } from 'react';
import { Paperclip, X, Loader2, FileText, ExternalLink } from 'lucide-react';
import api from '../../utils/api';

const fmt = b => b < 1048576 ? `${(b/1024).toFixed(1)} KB` : `${(b/1048576).toFixed(1)} MB`;

const FileUpload = ({ value, onChange, label = 'File', accept = '.pdf,.doc,.docx,.xls,.xlsx,image/*' }) => {
  const [uploading, setUploading] = useState(false);
  const [error, setError]         = useState('');
  const [info, setInfo]           = useState(null);
  const inputRef = useRef();

  const handleFile = async (file) => {
    if (!file) return;
    setError('');
    const fd = new FormData();
    fd.append('file', file);
    setUploading(true);
    try {
      const res = await api.post('/upload/file', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      setInfo({ name: res.data.originalName, size: res.data.size, url: res.data.url });
      onChange(res.data.url);
    } catch (err) {
      setError(err.response?.data?.message || 'Upload failed');
    } finally { setUploading(false); }
  };

  const clear = () => { setInfo(null); onChange(''); if (inputRef.current) inputRef.current.value = ''; };
  const disp = info || (value ? { name: value.split('/').pop(), url: value } : null);

  return (
    <div className="mb-3">
      {label && <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1.5">{label}</label>}
      {disp ? (
        <div className="flex items-center gap-3 p-3 bg-gray-50 border border-gray-200 rounded-xl">
          <FileText size={20} className="text-royal-600 flex-shrink-0" />
          <div className="flex-1 min-w-0">
            <div className="text-sm font-medium truncate">{disp.name}</div>
            {disp.size && <div className="text-xs text-gray-400">{fmt(disp.size)}</div>}
          </div>
          {disp.url && <a href={disp.url} target="_blank" rel="noreferrer" className="text-royal-600 hover:text-royal-800"><ExternalLink size={15} /></a>}
          <button type="button" onClick={clear} className="text-red-400 hover:text-red-600"><X size={16} /></button>
        </div>
      ) : (
        <div onClick={() => !uploading && inputRef.current?.click()}
          onDrop={e => { e.preventDefault(); handleFile(e.dataTransfer.files[0]); }}
          onDragOver={e => e.preventDefault()}
          className="flex flex-col items-center py-6 gap-1.5 border-2 border-dashed border-gray-200 rounded-xl bg-gray-50 hover:border-royal-400 hover:bg-royal-50 cursor-pointer transition-all text-gray-400">
          {uploading
            ? <><Loader2 size={22} className="animate-spin text-royal-600" /><span className="text-xs">Uploading...</span></>
            : <><Paperclip size={22} /><span className="text-sm font-medium">Click or drag file</span><span className="text-xs">PDF, DOCX, XLSX · max 20 MB</span></>
          }
        </div>
      )}
      {error && <p className="text-red-500 text-xs mt-1">❌ {error}</p>}
      <input ref={inputRef} type="file" accept={accept} className="hidden" onChange={e => handleFile(e.target.files[0])} />
    </div>
  );
};
export default FileUpload;
